export default class InfoText {
    static init(): void {
        const infoTexts = document.querySelectorAll('.info-text');

        infoTexts.forEach((infoText) => {

            // Create info text element near the cursor position
            document.addEventListener('mouseover',(event: MouseEvent) => {
                // if target is not any .info-text element
                const target = event.target as HTMLElement;

                if (!target.classList.contains('info-text')) {
                    const infoTextElement = document.getElementById('info-text__element');
                    if (infoTextElement) {
                        infoTextElement.remove();
                    }
                    return;
                }

                if (target !== infoText) {
                    return;
                }

                let infoTextElement = document.getElementById('info-text__element');
                if (!infoTextElement) {
                    infoTextElement = document.createElement('div');
                    infoTextElement.setAttribute('id', 'info-text__element');
                }

                    const text = infoText.getAttribute('data-info-text');
                    if (!text) return;
                    console.log(text)

                    infoTextElement.innerHTML = text;
                    infoTextElement.style.top = `${event.clientY + 10}px`;
                    infoTextElement.style.left = `${event.clientX + 10}px`;
                    document.body.appendChild(infoTextElement);
            });


        });

    }
}
